import * as yup from 'yup';
import { jobBoardI18n } from '@/i18n';
import type { ApplyFormModel } from './apply.model';

export function getApplySchema(applicationFields: Record<string, any>) {
   const requiredMsg = jobBoardI18n.global.t('live-editor.content-blocks.errors.required');

   const base: Record<keyof ApplyFormModel, any> = {
      first_name: yup.string().trim().required(requiredMsg),
      last_name: yup.string().trim().required(requiredMsg),
      phone_number: yup.string().trim().required(requiredMsg),
      email: yup.string().trim().email(),
      address: yup.object().shape({ city_id: yup.string() }).nullable(),
      motivation: yup.string().trim(),
      date_of_birth: yup.date().nullable(),
      cv: yup.mixed().nullable(),
      photo: yup.mixed().nullable(),
   };

   // Always required fields (not configurable)
   // "first_name", and "last_name" are not in applicationFields ("name" is) configurable fields
   const shape: Record<string, any> = {
      first_name: base.first_name,
      last_name: base.last_name,
      phone_number: base.phone_number,
   };

   // if a field is required in applicationFields, make it required in the schema
   (Object.keys(applicationFields) as (keyof ApplyFormModel)[]).forEach((key) => {
      // Skip always-required fields as they're already added
      if (key === 'first_name' || key === 'last_name' || key === 'phone_number') return;

      // if truthy is .required validation
      if (applicationFields[key]) {
         shape[key] = base[key].required(requiredMsg);
      } else {
         shape[key] = base[key];
      }
   });

   return yup.object(shape);
}
